<mat-form-field  [class]="imageSizeClass">
  <mat-select [(value)]="selectedSize" (selectionChange)="onSizeChange()">
    <mat-option *ngFor="let size of sizeOptions" [value]="size">
      {{ "InspectionResult.Tabs.GalleryOverview.Size." + size | i18next }}</mat-option
    >
  </mat-select>
</mat-form-field>
